import DataImportAPI from '../../apis/master-template-data-import-api';

const SourceFilterActions = {
  loadSources() {
    return DataImportAPI.index();
  },
};

export default SourceFilterActions;
